
































import Vue from 'vue'
import iNoBounce from 'inobounce'

import types from '../../store/types'
import BaseButton from '../Base/Button.vue'

export default Vue.extend({
  components: {
    BaseButton
  },

  data(): {
    isView: boolean,
    isViewAnimate: boolean,
    isClose: boolean,
    isCloseAnimate: boolean
  } {
    return {
      isView: false,
      isViewAnimate: false,
      isClose: false,
      isCloseAnimate: false
    }
  },

  computed: {
    modalClass(): {
      'view': boolean,
      'view-animate': boolean,
      'close': boolean,
      'close-animate': boolean,
    } {
      return {
        'view': this.isView,
        'view-animate': this.isViewAnimate,
        'close': this.isClose,
        'close-animate': this.isCloseAnimate
      }
    }
  },

  mounted() {
    if (this.$store.state.App.isInitEditor) {
      this.showModal()
      this.$store.commit(types.mutations.APP_INIT_EDITOR, false)
    }
  },

  methods: {
    showModal(): void {
      iNoBounce.disable()

      this.isView = false
      this.isViewAnimate = false
      this.isCloseAnimate = false
      this.isClose = false
      setTimeout(() => {
        this.isView = true

        setTimeout(() => {
          this.isViewAnimate = true
        }, 10)
      }, 10)
    },
    closeModal(): void {
      iNoBounce.enable()

      this.isCloseAnimate = true
      setTimeout(() => {
        this.isClose = true
      }, 300)
    }
  }
})
